module.exports = __webpack_public_path__ + "img/5.54547377.png";